import suchmethodeServiceImage from "../assets/Images/medical-services/garantien-service.jpg";
import executiveSearchServiceImage from "../assets/Images/medical-services/executive-search-service.jpg";
import praxisnachfolgerServiceImage from "../assets/Images/medical-services/praxisnachfolger-service.jpg";
import garantienServiceImage from "../assets/Images/medical-services/garantien-service.jpg";

export const HC_SERVICES = [
  {
    id: "suchmethode",
    title: "Suchmethode",
    heroSubheading: "Direktansprache und Headhunting für Fach- und Führungskräfte in der Medizinbranche.",
    desc:
      "Wir identifizieren qualifizierte Fach- und Führungskräfte gezielt im verdeckten Arbeitsmarkt und sprechen passende Kandidaten direkt für unsere Kunden an.",
    image: suchmethodeServiceImage,
    to: "/medical/focus/biopharma",
    detail: {
      sections: [
        {
          leftLabel: "DIREKTANSPRACHE",
          heading: "Headhunting/ Direktansprache in der Medizinbranche",
          shortLabel: "Direktansprache",
          paragraphs: [
            "Bei der Personalbeschaffung in der Direktansprache werden für unsere Kunden Kandidaten erreichbar gemacht, die eigentlich keine aktuellen Veränderungsabsichten haben, jedoch für unsere Kunden eine tragende Säule des Unternehmens werden könnten.",
            "Hier sind wir ein erfahrener Suchpartner, der mit dem nötigen Know-how, Branchenkenntnis und vor allem dem nötigen Feingefühl, Ihren Wunschkandidaten, zu Ihnen an Bord bringt.",
          ],
        },
        {
          leftLabel: "SPEZIALISTEN",
          heading:
            "REPEXO medical die Spezialisten in der Direktansprache von Medizinpersonal am Markt, dem klassischen Headhunting!",
          shortLabel: "Spezialisten",
          paragraphs: [
            "Wir sind spezialisiert auf die Direktansprache / Headhunting von Positionen im Health Care-Bereich auf allen Ebenen! Die Beauftragung erfolgt immer nach einem eingehenden Gespräch mit unserem Mandanten, bei dem wir auch stets unser Gesamthonorar mit unseren Mandanten definieren, (Drittellösung).",
          ],
        },
        {
          leftLabel: "VORGEHENSWEISE",
          heading:
            "REPEXO medical macht mit der speziellen Vorgehensweise in der Direktansprache den Unterschied für IHRE Personalsuche!",
          shortLabel: "Vorgehensweise",
          paragraphs: [
            "Was uns bei der Direktsuche so besonders erfolgreich macht, ist unsere spezielle Vorgehensweise bei der Suche und Beurteilung von Kandidaten. All unsere Berater verfügen über einen großen Erfahrungsschatz und ein großes Kontaktnetz. Was unsere Fachleute daran so sehr reizt? Die spezielle Herausforderung! Dabei spielen natürlich auch wichtige Faktoren wie Ethik, Diskretion und Ehrlichkeit gegenüber Klienten und Kandidaten eine wesentliche Rolle.",
            "Bei uns durchlaufen die Kandidaten ein mehrstufiges Testverfahren. Von der ersten Kontaktaufnahme am Telefon, über strukturierte persönliche Interviews, hin zu ausgefeilten Potentialanalysen nach neuesten psychologischen Erkenntnissen.",
          ],
        },
        {
          leftLabel: "GARANTIE",
          heading:
            "Unsere Garantie in der Personalberatung ist für Sie als Kunde sehr viel Wert!",
          shortLabel: "Garantie",
          paragraphs: [
            "Sie als Auftraggeber haben mit Sicherheit die Garantie, dass wir den richtigen Kandidaten für Sie finden, da wir im Vorfeld eine eingehende Situationsanalyse und ein Briefing-Gespräch mit Ihnen führen und Ihnen dann direkt sagen können, ob wir Ihren Suchauftrag ausführen. Denn erst wenn wir Ihren Wunsch verstanden haben und dafür auch realistische Chancen sehen, nehmen wir Ihren Auftrag gewissenhaft an.",
            "Wir arbeiten zügig und mit großem Erfolg, dies können Ihnen viele zufriedene Kunden bestätigen. Sprechen Sie uns an, wir nennen Ihnen gerne Referenzkunden.",
          ],
        },
      ],
      cta: {
        heading:
          "Ohne Kompromisse: transparent - zügig - passgenau - nachhaltig",
        shortLabel: "Jetzt anfragen",
        buttonText: "Nehmen Sie Kontakt mit uns auf",
      },
      showContactForm: true,
    },
  },
 
  {
    id: "executive-search",
    title: "Executive Search",
    heroSubheading: "Punktgenaues Finden von Führungskräften und Spezialisten durch Headhunting.",
    desc:
      "Wir finden erfahrene Führungskräfte und Spezialisten aus relevanten Branchen, die perfekt zu den Anforderungen unserer Mandanten passen.",
    image: executiveSearchServiceImage,
    to: "/medical/focus/medtech",
    detail: {
      sections: [
        {
          leftLabel: "UNSERE METHODIK",
          heading:
            "Punktgenaues Zusammenbringen von Kandidaten aus den medizinischen Bereichen und den suchenden Firmen. Die Erfahrung unserer Berater zählt für Ihr Unternehmen.",
          shortLabel: "Über uns",
          paragraphs: [
            "Wie wir - die REPEXO medical - im Rahmen unserer Suchmethode der Direktansprache qualifizierte Führungskräfte und Spezialisten aus Unternehmen und vergleichbaren Strukturen für unsere Kunden suchen und finden.",
            "\"Viele Wege führen nach Rom\". Wir bieten für unsere Kunden den besten und effektivsten Weg - nämlich Headhunting - um in einem relativ kurzen Zeitfenster die besten Kandidaten vom Markt zu selektieren.",
            "Dabei kombinieren wir keine Suchmethode, sondern arbeiten explizit mit der Methode der Direktansprache, dem Headhunting, für unsere Unternehmen, die uns beauftragen. Bei unserer Methodik des Executive Search, dem Headhunting, haben wir es immer mit Kandidaten zu tun, die keine unmittelbaren Wechselabsichten haben. Mit unserer direkten Ansprache der potenziellen Kandidaten informieren wir nicht nur über die nächsten Karrieremöglichkeiten, sondern wir holen diskret dort die Kandidaten ab, wo sie gerade stehen.",
          ],
        },
        {
          leftLabel: "IHRE VORTEILE",
          heading:
            "Personalberatung im Headhunting ist die sicherste Methode wirklich gute neue Mitarbeiter an Bord zu holen!",
          shortLabel: "Personalberatung",
          cards: [
            { text: "Feinfühlige und punktgenaue Ansprache - zentral für Executive Search (Headhunting Medizin).", icon: "User" },
            { text: "Viel Branchenkenntnis und Erfahrung im Umgang mit Kandidaten - unser tägliches Handwerk.", icon: "Building2" },
            { text: "Zum Vorteil unserer Kunden: In Zeiten großer Veränderung von Märkten und Plattformen nehmen die Angebote für Kandidaten zu.", icon: "TrendingUp" },
            { text: "Wir bleiben Ihre verlässliche Partnerin für zielgenaue und diskrete Besetzungen.", icon: "ShieldCheck" },
          ],
        },
        {
          leftLabel: "UNSERE EXPERTISE",
          heading: "Man braucht Fachleute um gutes Personal zu rekrutieren!",
          shortLabel: "Fachleute",
          paragraphs: [
            "Hier hilft auch unsere langjährige Markt- und Markenpräsenz sehr schnell vertrauenswürdig mit den richtigen Kandidaten in Kontakt zu kommen.",
          ],
        },
      ],
      cta: {
        heading:
          "Damit unsere Kunden zügig und vor allem langfristig ihre neuen Mitarbeiter an Bord bekommen.",
        shortLabel: "Jetzt anfragen",
        buttonText: "Nehmen Sie Kontakt mit uns auf",
        smallerHeading: true,
      },
      showContactForm: true,
    },
  },
  {
    id: "praxisnachfolger",
    title: "Praxisnachfolger-Suche",
    heroSubheading: "Gezielte Suche nach Nachfolgern - von der Situationsanalyse bis zur Vertragsgestaltung.",
    desc:
      "Wir unterstützen Ärzte und Praxisinhaber bei der gezielten Suche nach qualifizierten Nachfolgern für eine erfolgreiche Praxisübergabe.",
    image: praxisnachfolgerServiceImage,
    to: "/medical/focus/medtech",
    detail: {
      sections: [
        {
          leftLabel: "PRAXISNACHFOLGE",
          heading: "Praxisnachfolge-Suche",
          shortLabel: "Überblick",
          paragraphs: [
            "Als langjährig tätige Beratungsgesellschaft am Markt verfügen wir natürlich über eine große Anzahl ausgezeichneter Kontakte! Vor allem aber bieten wir Ihnen hier eine große Plattform mit der Möglichkeit, ganz gezielt wertvolle Kontakte für Ihr Anliegen zu suchen, zu finden und so einen Mehrwert für beide Parteien zu schaffen.",
            "Täglich sind wir mit vielen Ärzten oder anderen Spezialisten aus den medizinischen Branchen im Dialog. So auch mit Ärztinnen und Ärzten, die aufgrund ihrer hervorragenden Fachkompetenzen und besten persönlichen Voraussetzungen in eine Praxis einsteigen möchten, um einen Kassensitz im Angestelltenverhältnis zu übernehmen. Oder auch Ärztinnen und Ärzte, die sich mit einer finanziellen Investition in einer Praxis oder einem medizinischen Versorgungszentrum einbringen wollen.",
            "Hier umfasst unser Leistungsangebot, je nach Klienten-Wunsch, das gesamte Spektrum der Ärzteauswahl und Beschaffung. Gerne begleiten wir Sie von der Situationsanalyse bis zu Ihren Vertragsverhandlungen.",
            "Für die juristische Beratung rund um den Abschluss von Verträgen für eine Praxisvermittlung oder ähnlichem steht Ihnen auf Wunsch unser Kooperationspartner Baumann & Baumann zur Verfügung.",
          ],
        },
      ],
      cta: {
        heading:
          "Praxisnachfolge gezielt angehen - wir begleiten Sie von der Analyse bis zur Vertragsgestaltung.",
        buttonText: "Jetzt unverbindlich anfragen",
        shortLabel: "Jetzt anfragen",
      },
      showContactForm: true,
    },
  },
  {
    id: "garantien",
    title: "Garantien",
    heroSubheading: "Kompromisslose Qualitätsmaßstäbe in der Zusammenarbeit mit unseren Klienten.",
    desc:
      "In der Zusammenarbeit mit unseren Klienten haben wir uns kompromisslos hohe Qualitätsmaßstäbe auferlegt.",
    image: garantienServiceImage,
    to: "/medical/focus/diagnostics-labs",
    detail: {
      sections: [
        {
          leftLabel: "QUALITÄTSGARANTIE",
          heading: "Allgemeine Qualitätsgarantie für alle Geschäftsfelder",
          shortLabel: "Qualitätsgarantie",
          paragraphs: [
            "In der Zusammenarbeit mit unseren Klienten haben wir uns kompromisslos hohe Qualitätsmaßstäbe auferlegt. Diese betreffen natürlich alle Geschäftsfelder unseres Unternehmens.",
            "Eine dauerhaft konsequente Überprüfung unserer Qualitätsstandards ist für uns selbstverständlich.",
          ],
        },
      ],
      cta: {
        shortLabel: "Jetzt anfragen",
        buttonText:
          "Wir haben Sie überzeugt? Dann nehmen Sie Kontakt zu uns auf!",
      },
      showContactForm: true,
    },
  },
];

